var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31,
    stroke: "#03CDEF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 18.5C45.15 18.5 46.5 19.85 46.5 21.5V42.5C46.5 44.15 45.15 45.5 43.5 45.5H22.5C20.85 45.5 19.5 44.15 19.5 42.5V21.5C19.5 19.85 20.85 18.5 22.5 18.5H28.77C29.4 16.76 31.05 15.5 33 15.5C34.95 15.5 36.6 16.76 37.23 18.5H43.5ZM33 18.5C32.175 18.5 31.5 19.175 31.5 20C31.5 20.825 32.175 21.5 33 21.5C33.825 21.5 34.5 20.825 34.5 20C34.5 19.175 33.825 18.5 33 18.5ZM25.5 24.5V21.5H22.5V42.5H43.5V21.5H40.5V24.5H25.5ZM33 27.5C34.65 27.5 36 28.85 36 30.5C36 32.15 34.65 33.5 33 33.5C31.35 33.5 30 32.15 30 30.5C30 28.85 31.35 27.5 33 27.5ZM27 39.5V38C27 36.35 29.685 35 33 35C36.315 35 39 36.35 39 38V39.5H27Z",
    fill: "#03CDEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserIcon);
export default __webpack_public_path__ + "static/media/EditUserIcon.95c9b36c9cc7d896a4d28641f13fcb7b.svg";
export { ForwardRef as ReactComponent };